import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { ForgeUserProfile, ForgeProfileLink } from '@tylertech/forge-extended-react';
import { ForgeIcon } from '@tylertech/forge-react';
import { setDefaultTheme } from '../../../services/userService.js';
import { Context } from '../../../store/Store.js';
import { LOCAL_STORAGE_KEYS } from '../../../static/localStorageStrings.js';
import { REDUCER_ACTION_TYPES } from '../../../store/Reducer.js';
import { NAVIGATION_PATHS } from '../../../static/navigationPaths.js';
import { useUser } from '../../../contexts/userContext.js';

const MyProfile = ({ handleLogout }) => {
  const [, dispatch] = useContext(Context);
  const { user, lastPath } = useUser();

  useEffect(() => {
    const themeAttributeName = 'data-forge-theme';

    const updateTheme = () => {
      const theme = document.documentElement.getAttribute(themeAttributeName);
      if (theme) {
        dispatch({ type: REDUCER_ACTION_TYPES.TOGGLE_THEME, payload: theme });
        document.body.setAttribute('data-ag-theme-mode', theme);
        localStorage.setItem(LOCAL_STORAGE_KEYS.THEME, theme);
        setDefaultTheme({ theme: theme });
      }
    };

    // Set theme initially
    updateTheme();

    // Watch for changes of the theme attribute
    const observer = new MutationObserver(updateTheme);

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: [themeAttributeName],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <ForgeUserProfile 
      slot="end"
      email={user?.email}
      fullName={user?.firstName + ' ' + user?.lastName}
      themeToggle={true}
      onForgeUserProfileSignOut={handleLogout}
    >
      <ForgeProfileLink
        slot="link"
      >
        <ForgeIcon external externalType="all"slot="icon" name="account" />
        <Link to={{ pathname: `/${lastPath.orgId}/${lastPath.budgetId}/${NAVIGATION_PATHS.USER_PROFILE}` }}>
          Profile
        </Link>
      </ForgeProfileLink>
    </ForgeUserProfile>
  );
};

MyProfile.propTypes = {
  handleLogout: PropTypes.func.isRequired,
};

export default MyProfile;
